import { makeAutoObservable } from 'mobx'

export class CartStore {
  constructor (rootStore) {
    this.rootStore = rootStore
    this.cartItems = []
    this.totalItems = 0
    this.cartInfo = {}
    makeAutoObservable(this)
  }

  getCart = async () => {
    const res = await this.rootStore.api.cart.getCart()
    this.cartInfo = res

    return res
  }

  clearCart = async () => {
    await this.rootStore.api.cart.postClearCart()
    this.cartItems = []
    this.totalItems = 0
  }

  removeCartItem = async (id) => {
    await this.rootStore.api.cart.deleteCartItem(id)
    this.cartItems = this.cartItems.filter(item => item.cart_item_id !== id)
    this.totalItems = this.totalItems - 1
  }

  getCartItems = async () =>  {
    const res = await this.rootStore.api.cart.getCartItems()
    this.cartItems = res
    this.totalItems = res.length

    return res
  }

  addCartItem = async (params) => {
    const res = await this.rootStore.api.cart.postCartItem(params)
    this.cartItems = [...this.cartItems, res]
    this.totalItems = this.totalItems + 1

    return res
  }

  editCartItem = async (id, params) => {
    const res = await this.rootStore.api.cart.putCartItem(id, params)
    this.cartItems = this.cartItems.map(item => item.cart_item_id === id ? res : item)

    return res
  }

  editCart = async (id, params) => {
    const res = await this.rootStore.api.cart.putCart(id, params)
    this.cartInfo = res

    return res
  }
  
}